import tippy from 'tippy.js';

const {registerModule} = window;

window.tippyInstances = window.tippyInstances || [];

class ShareLinks {
  constructor(element) {
    this.element = element;
    this.initialize();
  }


  bindUI() {
  }

  initialize() {
    this.bindUI();
    this.setVars();

    if (this.copyLinkUrlIcon) {
      this.copyLinkUrlIcon.addEventListener('click', () => {
        navigator.clipboard.writeText(location.href);
      });

      const theme = Array.from(this.element.classList).find((x) => /^theme/.test(x));

      const tippyContent = `
          <span class="sharing-links__copy-content"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.585L9.70711 11.2929L9.6129 11.2097C9.22061 10.9047 8.65338 10.9324 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071L10.3871 14.7903C10.7794 15.0953 11.3466 15.0676 11.7071 14.7071L15.7071 10.7071L15.7903 10.6129C16.0953 10.2206 16.0676 9.65338 15.7071 9.29289Z" fill="#042A2D"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z" fill="#042A2D"/>
          </svg>
          <span class="type-body">Copied to clipboard</span>
          </span>`;

      tippy(this.copyLinkUrlIcon, {
        content: tippyContent,
        trigger: 'click',
        theme: `${theme} sharing-links-copy-link-tippy`,
        allowHTML: true,
        maxWidth: 'none',
      });
    }
  }

  setVars() {
    // Define variables
    this.copyLinkUrlIcon = this.element.querySelector('[data-copy-url]');
  }
}

registerModule('ShareLinks', ShareLinks);
